import React from "react";
import { connect } from "react-redux";
import LoadingAnimation from "../../../Utils/loadingAnimation.js";
import Network from "../../../Utils/network.js";
import GeneralUtils from "../../../Utils/generalUtils.js";
import { setPlanDetails, setCurrentPage, setRegisterDetails } from "../../../General/Actions";
import AddonCartComponent from "./ActivateAddonCartComponent";
import ServiceCartComponent from "../UpgradeOffer/UpgradeOfferCartComponent";
import { Button } from "reactstrap";
import Swal from "sweetalert2";
import moment from "moment";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import PathIcon from "../../../ImageAssets/pathIcon.png";
import MyAccountComponent from "../MyAccountComponent";
import Constants from "../../../Utils/constants.json";
import PaymentComponent from "./AddonPaymentComponent";
import ReceiptComponent from "../../../Utils/receiptModal";

class AddonsConfirmationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isTermsAndConditionsModalVisible: false,
            profileId: "NA",
            totalMonthlyCharges: 0,
            discount: 3.0,
            allServiceDetailsArray: [],
            allCurrentActiveServiceCharge: 0,
            finalOrderReq: {},
            carouselDetails: {
                superLargeDesktop: {
                    // the naming can be any, depends on you.
                    breakpoint: { max: 1285, min: 1000 },
                    items: 5,
                },
                desktop: {
                    breakpoint: { max: 850, min: 1000 },
                    items: 5,
                },
                mobile: {
                    breakpoint: { max: 850, min: 300 },
                    items: 3,
                },
            },
            isCartVisibleForMobile: false,
            redirectToMyAccount: false,
            feature: "",
            transactionId: "",
            isPaymentComponent: false,
            isReceiptModalVisible: false,
            isContinue: false,
            compatibleArr: [],
            inCompatibleArr: [],
            allExistingAddonIds: [],
            addSubscriptionType: this.props.registerDetails.generalResponse.type,
            redemptionPoint: "0",
            totalAmountToPay: 0,
            contactDetails: {},
            creditExpiryDate: "",
            powertranzOrderId: "", 
            powertranzTransId: "", 
            powertranzInitialResponse: ""
        };
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
        window.removeEventListener("message", this.processIframeMessage);
        clearInterval(this.pollingInterval);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
        window.addEventListener("message", this.processIframeMessage);
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
        this.initializeServiceListFromCache(this.props.cache.subscriberInfo);
        this.props.setRegisterDetails("isConfirmationReached", true);
        if (this.state.addSubscriptionType === "changePlan") {
            this.initialisePlanComparison();
        }
        if (this.props.registerDetails.services.packageName) {
            this.setState({
                packageName: this.props.registerDetails.services.packageName,
            });
        } else {
            this.setState({ packageName: "NA" });
        }
        if (this.props.registerDetails.services.packageAmount) {
            this.setState({
                packageAmount: this.props.registerDetails.services.packageAmount,
            });
        } else {
            this.setState({ packageAmount: "0" });
        }
        if (this.props.registerDetails.services.discount) {
            this.setState({
                discount: this.props.registerDetails.services.discount,
            });
        } else {
            this.setState({ discount: "0" });
        }

        if (this.props.registerDetails.services.packageDescription) {
            this.setState({
                packageDescription: this.props.registerDetails.services.packageDescription,
            });
        } else {
            this.setState({ packageDescription: "NA" });
        }

        var packageWithDiscount = 0;
        var packageWithDiscount_sup = 0;
        var discountPrice = GeneralUtils.formatNumberToStandardForm(
            parseFloat(this.props.registerDetails.services.packageAmount) -
                parseFloat(this.props.registerDetails.services.discount),
            this.props.configurationValues
        );
        discountPrice = discountPrice.split(".");
        packageWithDiscount = discountPrice[0];
        if (discountPrice.length > 1) {
            packageWithDiscount_sup = discountPrice[1];
        } else {
            packageWithDiscount_sup = "00";
        }
        this.setState({ packageWithDiscount: packageWithDiscount });
        this.setState({ packageWithDiscount_sup: packageWithDiscount_sup });
        this.initialiseRedemptionPoint();
        this.calculateTotalCharge();
        this.setState({ isLoading: false });
    }

    processIframeMessage = (event) => {
        // console.log("event data >> ",event.data);
        // set interval call status
        setTimeout(() => {
            this.pollingInterval = setInterval(() => this.checkCallbackStatus(event.data.orderId, event.data.transId), 3000);
        }, 2000);
    };

    checkCallbackStatus(orderId,transId) {
        Network.executeAxios("powertranzPaymentComplete", "POST", { orderId: orderId, transId : transId }, (response) => {
            // console.log("response >> ",response);
            if (response.paymentDetails && response.paymentDetails.status !== "INITIATED") {
                console.log("paymentComplete response >> ", response);
                clearInterval(this.pollingInterval);
                var reason = response.paymentDetails.reason;
                if (reason === "add_addon") {
                    reason = "addon subscription";
                } else if (reason === "change_plan") {
                    reason = "change plan";
                }
                if (response.paymentDetails.status === "SUCCESS") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Successful",
                            html:
                                "<div>Your payment for " +
                                reason +
                                " has been successful</div><div style='text-align:center'>Order Id : " +
                                response.paymentDetails.orderId +
                                "</div>",
                            type: "",
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if(response.paymentDetails.status === "ORDER_FAILED") {
                        var errSubHeadingMsgAddSubscription = "";
                        if (reason === "addon subscription") {
                            errSubHeadingMsgAddSubscription = this.props.locales.addAddonOrderFailedSwalSubHeading;
                        } else if (reason === "change plan") {
                            errSubHeadingMsgAddSubscription = this.props.locales.changePlanOrderFailedSwalSubHeading;
                        }
                        setTimeout(() => {
                        Swal.fire({
                            title: this.props.locales.orderFailedSwalHeadingInAddSubscription,
                            html:
                                "<div>"+errSubHeadingMsgAddSubscription+"</div><div style='text-align:center'>Order Id : " +
                                response.paymentDetails.orderId +
                                "</div>",
                            type: "",
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "FAILED") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Payment Failed",
                            html:
                                "<div>Your payment for " +
                                reason +
                                " has been Failed</div><div style='text-align:center'>Order Id : " +
                                response.paymentDetails.orderId +
                                "</div>",
                            type: "",
                            timer: 3000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                } else if (response.paymentDetails.status === "TO_REFUND") {
                    setTimeout(() => {
                        Swal.fire({
                            title: "Failed to place the order",
                            html: "<div>Amount debited will be refunded within 2 working days</div>",
                            type: "",
                            timer: 4000,
                            showCancelButton: false,
                            confirmButtonText: this.props.locales.okButtonTextInSwal,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }, 1000);
                }
            } else {
                console.log("waiting for callback...");
            }
        });
    }

    initializeServiceListFromCache(receivedSubscriberInfoResponse) {
        var reduxCache = this.props.cache;
        var maBalance = "0";
        var serviceCode = "";
        var serviceName = "";
        var currentCreditLimit = 0;
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalEmailId = "";
            var finalFirstName = "";
            var finalLastName = "";
            var finalProfileId = "";

            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
                if (params[i].id === "contact_email_id") {
                    finalEmailId = params[i].value;
                }
                if (params[i].id === "profile_id") {
                    finalProfileId = params[i].value;
                }
            }
            this.state.firstName = finalFirstName;
            this.state.lastName = finalLastName;
            this.state.contactEmailAddress = finalEmailId;
            this.state.contactNumber = finalContactNumber;
            this.state.profileId = finalProfileId;
        } catch (err) {}
        try {
            var serviceParams = receivedSubscriberInfoResponse.service_info.basic_details;
            var finalPlanId = "";
            var finalPlanName = "";
            var creditExpiryDate = "";

            for (var j = 0; j < serviceParams.length; j++) {
                if (serviceParams[j].id === "rate_plan_id") {
                    finalPlanId = serviceParams[j].value;
                }
                if (serviceParams[j].id === "rate_plan_name") {
                    finalPlanName = serviceParams[j].value;
                }
                if (serviceParams[j].id === "maBalance") {
                    maBalance = serviceParams[j].value;
                }
                if (serviceParams[j].id === "service_code") {
                    serviceCode = serviceParams[j].value;
                }
                if (serviceParams[j].id === "currentCreditLimit") {
                    currentCreditLimit = serviceParams[j].value;
                }
                if (serviceParams[j].id === "creditExpiryDate") {
                    creditExpiryDate = serviceParams[j].value;
                }

                if (serviceParams[j].id === "service_name") {
                    serviceName = serviceParams[j].value;
                }
            }
            this.state.creditExpiryDate = creditExpiryDate;
            this.state.currentPlanId = this.props.cache.currentPlanDetails.planId;
            this.state.currentPlanName = finalPlanName;

            console.log("maBalance>>>>>", maBalance);
        } catch (err) {}
        try {
            var accountData = receivedResponse.account_info.basic_details;
            var accountId = "";
            for (var k = 0; k < accountData.length; k++) {
                if (accountData[k].id === "account_id") {
                    accountId = accountData[k].value;
                }
            }
            this.state.accountId = accountId;
        } catch (err) {
            accountData = [];
        }

        var serviceAddress = {};

        try {
            var AddressParams = this.props.cache.serviceListResponse[0];
            if (AddressParams && AddressParams.addresses) {
                serviceAddress = AddressParams.addresses[0];
            }
        } catch (err) {}

        var givenAddress = {
            AddressLine1: serviceAddress.addr_line1,
            city: serviceAddress.addr_line2,
            state: serviceAddress.addr_line3,
            zip: serviceAddress.addr_line4,
            AddressLine2: serviceAddress.addr_line2,
            AddressLine6: serviceAddress.addr_line6,
            SiteId: serviceAddress.addr_line6,
            serviceId: this.props.cache.serviceInfo.serviceId,
            profileId: this.state.profileId,
        };

        this.state.givenAddress = givenAddress;

        var contactDetails = {};
        contactDetails["firstName"] = this.state.firstName;
        contactDetails["lastName"] = this.state.lastName;
        contactDetails["contactEmailAddress"] = this.state.contactEmailAddress;
        contactDetails["contactNumber"] = this.state.contactNumber;
        contactDetails["profileId"] = this.state.profileId;
        contactDetails["accountId"] = this.state.accountId;
        contactDetails["currentPlanId"] = this.state.currentPlanId;
        contactDetails["currentPlanName"] = this.state.currentPlanName;
        contactDetails["serviceId"] = this.props.cache.serviceInfo.serviceId;
        contactDetails["serviceCode"] = serviceCode;
        contactDetails["serviceName"] = serviceName;
        contactDetails["currentCreditLimit"] = currentCreditLimit;
        this.props.setRegisterDetails("generalResponse.currentCreditLimit", currentCreditLimit);

        this.setState({ contactDetails: contactDetails });
    }

    initialiseRedemptionPoint() {
        var redemptionPoint = "0";
        try {
            var ccmConfig = this.props.cache.ccmConfigResponse;
            redemptionPoint = ccmConfig["_embedded"].configs[0].configValue;
        } catch (err) {}
        this.setState({ redemptionPoint: redemptionPoint });
    }

    initialisePlanComparison() {
        var compatibleArr = [];
        var inCompatibleArr = [];
        var allExistingAddonIds = [];
        for (
            var a = 0;
            a < this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails.length;
            a++
        ) {
            var currentObj = this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails[a];
            if (currentObj.retainable === "true") {
                for (
                    var b = 0;
                    b < this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails.length;
                    b++
                ) {
                    var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails[b];
                    if (oldObj.planId === currentObj.planId) {
                        var tempCompatible = {
                            subscription_id: oldObj.subscriptionId,
                            plan_id: oldObj.planId,
                            plan_name: oldObj.planName,
                        };
                        compatibleArr.push(tempCompatible);
                        allExistingAddonIds.push(currentObj.planId);
                    }
                }
            } else if (currentObj.retainable === "false") {
                var tempIncompatible = {
                    subscription_id: currentObj.subscriptionId,
                    plan_id: currentObj.planId,
                    plan_name: currentObj.planName,
                };
                inCompatibleArr.push(tempIncompatible);
            }
        }
        for (
            var j = 0;
            j < this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices.length;
            j++
        ) {
            var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices[j];
            var tempCompatible = {
                subscription_id: oldObj.subscriptionId,
                plan_id: oldObj.planId,
                plan_name: oldObj.planName,
            };
            compatibleArr.push(tempCompatible);
            allExistingAddonIds.push(oldObj.planId);
        }
        this.setState({
            compatibleArr: compatibleArr,
            inCompatibleArr: inCompatibleArr,
            allExistingAddonIds: allExistingAddonIds,
        });
    }

    calculateTotalCharge() {
        let sum = 0;
        var totalAmountToPay = 0;
        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            if (this.state.addSubscriptionType === "changePlan") {
                var isExistingAddon = false;
                var oldCartDetails = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails;
                for (var k = 0; k < oldCartDetails.length; k++) {
                    if (oldCartDetails[k].planId === this.props.registerDetails.customize.addons[i].id) {
                        isExistingAddon = true;
                    }
                }
                if (isExistingAddon == false) {
                    sum = sum + parseFloat(this.props.registerDetails.customize.addons[i].addonPriceWithDiscount || 0);
                    if (this.props.registerDetails.customize.addons[i].connectionType.toUpperCase() === "PREPAID") {
                        totalAmountToPay =
                            totalAmountToPay +
                            parseFloat(this.props.registerDetails.customize.addons[i].addonPriceWithDiscount || 0) *
                                this.props.registerDetails.customize.addons[i].count;
                    }
                }
            } else {
                if (this.props.registerDetails.customize.addons[i].connectionType.toUpperCase() === "PREPAID") {
                    totalAmountToPay =
                        totalAmountToPay +
                        parseFloat(this.props.registerDetails.customize.addons[i].addonPriceWithDiscount || 0) *
                            this.props.registerDetails.customize.addons[i].count;
                }
                sum =
                    sum +
                    parseFloat(this.props.registerDetails.customize.addons[i].addonPriceWithDiscount || 0) *
                        this.props.registerDetails.customize.addons[i].count;
            }
        }

        if (this.state.addSubscriptionType === "changePlan") {
            if (this.props.cache.currentPlanDetails.isContractExpired == false) {
                sum =
                    sum +
                    parseFloat(this.props.registerDetails.offers.basePriceWithDiscount) +
                    parseFloat(this.props.registerDetails.contractDetails.price);
                if (this.props.registerDetails.offers.connectionType.toUpperCase() === "PREPAID") {
                    totalAmountToPay =
                        totalAmountToPay +
                        parseFloat(this.props.registerDetails.offers.basePriceWithDiscount) +
                        parseFloat(this.props.registerDetails.contractDetails.price);
                }
            } else {
                sum = sum + parseFloat(this.props.registerDetails.offers.basePriceWithDiscount);
                if (this.props.registerDetails.offers.connectionType.toUpperCase() === "PREPAID") {
                    totalAmountToPay =
                        totalAmountToPay + parseFloat(this.props.registerDetails.offers.basePriceWithDiscount);
                }
            }
            sum = sum - parseFloat(this.props.registerDetails.offers.discount);
            totalAmountToPay = totalAmountToPay - parseFloat(this.props.registerDetails.offers.discount);
        }

        this.state.totalMonthlyCharges = sum;
        this.setState({ totalAmountToPay: totalAmountToPay });
    }
    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    };

    confirmationBackButtonClicked() {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
        this.props.setRegisterDetails("isConfirmationReached", false);
        this.props.callBack("back");
    }

    confirmationSubmitButtonClicked() {
        if (this.state.addSubscriptionType === "addAddon" || this.state.addSubscriptionType === "addFnFAddon") {
            this.props.setRegisterDetails("generalResponse.rechargeDetails", {});
            this.setState({
                finalPaymentAmount: this.state.totalMonthlyCharges,
                isPaymentComponent: true,
            });
        } else if (this.state.addSubscriptionType === "changePlan") {
            //this.finalAddSubscriptionCall();
            this.setState({
                finalPaymentAmount: this.state.totalMonthlyCharges,
                isPaymentComponent: true,
            });
        }
    }

    addContractViolationCharge() {
        var receivedServiceDetails = this.props.registerDetails.offers;
        try {
            var item = this.props.registerDetails.contractDetails;
            var taxCategoryId = "";
            if (item.priceCode && item.priceCode.taxCategoryId) {
                taxCategoryId = item.priceCode.taxCategoryId;
            }

            var prorata_flags = "";
            try {
                var prorataEnabledInSuspension = item.prorataEnabledInSuspension ? "1" : "0";
                var prorataEnabledInTermination = item.prorataEnabledInTermination ? "1" : "0";
                var prorataEnabledInPlanChange = item.prorataEnabledInPlanChange ? "1" : "0";
                var prorataEnabledInActivation = item.prorataEnabledInActivation ? "1" : "0";
                prorata_flags =
                    prorataEnabledInActivation +
                    prorataEnabledInTermination +
                    prorataEnabledInSuspension +
                    prorataEnabledInPlanChange;
            } catch (err) {
                prorata_flags = "";
            }

            // var effective_date = receivedDeviceDetails[i].effective_date;
            // var effective_date_formatted = moment(effective_date, "MM/DD/YYYY").format("DDMMYYYY") + "000000";
            // var expiry_date = receivedDeviceDetails[i].expiry_date;
            // var expiry_date_formatted = ""
            // if (expiry_date != "" && expiry_date != undefined) {
            //     expiry_date_formatted = moment(expiry_date, "MM/DD/YYYY").format("DDMMYYYY") + "000000";
            // }

            let tempCharges = {
                upc_charge_id: item.id,
                charge_type: item.priceMode.id,
                charge_name: item.name,
                //"charge_desc": item.description,
                charge_amount: item.price,
                start_date: moment().format("MM/DD/YYYY HH:mm:ss"),
                end_date: moment().format("MM/DD/YYYY HH:mm:ss"),
                charge_tax: taxCategoryId,
                total_charge: item.price,
                charge_validity: "",
                charge_category: item.priceCategory.id,
                charge_id: item.id,
                discount_type: item.priceType.name,
                epc_enabled: "1",
                quantity_based: "",
                charge_classification: "",
                charge_amount_type: item.priceType.name,
                charge_code: item.priceCode.id,
                is_prorata: item.prorataEnable ? "1" : "0",
                prorata_flags: prorata_flags,
            };
            var currentSubscription = receivedServiceDetails.subscriptionCharges;
            currentSubscription.push(tempCharges);
        } catch (err) {
            console.log("error1", err);
        }
    }

    generateChangePlanRequest() {
        var servicesSubscription = [];
        if (this.props.cache.currentPlanDetails.isContractExpired == false) {
            this.addContractViolationCharge();
        }
        var receivedServiceDetails = this.props.registerDetails.offers;

        var serviceSubscriptionsObj = {
            product_id: receivedServiceDetails.productId,
            product_name: receivedServiceDetails.productName,
            plan_id: receivedServiceDetails.id,
            plan_name: receivedServiceDetails.name,
            plan_desc: receivedServiceDetails.description,
            effective_date: receivedServiceDetails.effective_date,
            expiry_date: receivedServiceDetails.expiry_date,
            is_base_plan: "0",
            po_type: receivedServiceDetails.poType,
            po_sub_type: "0",
            plan_type: "1",
            product_family_id: receivedServiceDetails.productFamilyIdFromResponse,
            product_family_name: this.props.cache.currentPlanDetails.serviceName.toUpperCase(),
            status: "1",
            subscription_type: "0",
            version: receivedServiceDetails.psVesrion,
            subscription_charges: receivedServiceDetails.subscriptionCharges,
            cfss: receivedServiceDetails.cfss,
        };
        if (
            this.props.registerDetails.generalResponse &&
            this.props.registerDetails.generalResponse.changeBaseAddonData &&
            this.props.registerDetails.generalResponse.changeBaseAddonData.linkedPlanId
        ) {
            serviceSubscriptionsObj["linked_plan_id"] =
                this.props.registerDetails.generalResponse.changeBaseAddonData.linkedPlanId;
        }
        if (receivedServiceDetails.connectionType.toUpperCase() === "POSTPAID") {
            serviceSubscriptionsObj["apply_purchase_fee"] = "true";
        } else if (this.state.paymentMode === "mainBalance" || this.state.paymentMode === "mainBalanceRecharge") {
            serviceSubscriptionsObj["apply_purchase_fee"] = "true";
        } else {
            serviceSubscriptionsObj["apply_purchase_fee"] = "false";
        }
        servicesSubscription.push(serviceSubscriptionsObj);

        var receivedAddonDetails = this.props.registerDetails.customize.addons;
        for (var i = 0; i < receivedAddonDetails.length; i++) {
            var addonsSubscriptions = {
                product_id: receivedAddonDetails[i].productId,
                product_name: receivedAddonDetails[i].productName,
                plan_id: receivedAddonDetails[i].id,
                plan_name: receivedAddonDetails[i].name,
                plan_desc: receivedAddonDetails[i].description,
                effective_date: receivedAddonDetails[i].effective_date,
                expiry_date: receivedAddonDetails[i].expiry_date,
                is_base_plan: "0",
                po_type: receivedAddonDetails[i].poType,
                po_sub_type: "0",
                subscription_type: "0",
                subscription_charges: receivedAddonDetails[i].subscriptionCharges,
                cfss: receivedAddonDetails[i].cfss,
                pogIdFromResponse: receivedAddonDetails[i].pogIdFromResponse,
            };

            if (receivedAddonDetails[i].connectionType.toUpperCase() === "POSTPAID") {
                addonsSubscriptions["apply_purchase_fee"] = "true";
            } else if (receivedAddonDetails[i].isRedeemable && parseInt(this.state.totalRewardPointsUsed) > 0) {
                addonsSubscriptions["apply_purchase_fee"] = "false";
            } else if (this.state.paymentMode === "mainBalance" || this.state.paymentMode === "mainBalanceRecharge") {
                addonsSubscriptions["apply_purchase_fee"] = "true";
            } else {
                addonsSubscriptions["apply_purchase_fee"] = "false";
            }

            if (this.state.allExistingAddonIds.includes(receivedAddonDetails[i].id)) {
            } else {
                servicesSubscription.push(addonsSubscriptions);
            }
        }

        var tempContract = {};
        try {
            var contracts = this.props.registerDetails.offers.contract_details;
            if (contracts) {
                tempContract["contract_type"] = contracts.contractType.id;
                tempContract["contract_name"] = contracts.name;
                //var activationDate = moment(contracts.validFor.startDateTime).format(this.props.configurationValues.dateFormatForBilling)
                var activationDate = moment().format("MM/DD/YYYY HH:mm:ss");
                tempContract["activation_date"] = activationDate;
                tempContract["contract_desc"] = contracts.name;

                var frequency = "";
                if (contracts.frequency) {
                    if (contracts.frequency.id === "0") {
                        frequency = "days";
                    } else if (contracts.frequency.id === "1") {
                        frequency = "weeks";
                    } else if (contracts.frequency.id === "2") {
                        frequency = "months";
                    } else if (contracts.frequency.id === "3") {
                        frequency = "years";
                    } else {
                        frequency = "days"; // default
                    }
                }

                var contractPeriod = "0";
                if (contracts.contractPeriod) {
                    contractPeriod = contracts.contractPeriod.name;
                }

                var contractExpiryDate = "";
                try {
                    contractExpiryDate = moment(activationDate).add(contractPeriod, frequency);
                } catch (err) {
                    contractExpiryDate = moment(activationDate).add(0, frequency);
                }

                tempContract["expiry_date"] = moment(contractExpiryDate).format(
                    this.props.configurationValues.dateFormatForBilling
                );
            }
        } catch (err) {
            console.log("err>>>", err);
            tempContract = {};
        }

        var finalOrderReq = {
            order_information: {
                order_type: "AddSubscription",
                dataset: {
                    param: [
                        {
                            id: "entity_id",
                            value: "200",
                        },
                    ],
                },
                customer_name: this.state.contactDetails.firstName + " " + this.state.contactDetails.lastName,
                contact_number: this.state.contactDetails.contactNumber,
                service_management: {
                    service_id: this.state.contactDetails.serviceId,
                    profile_id: this.state.contactDetails.profileId,
                    account_id: this.state.contactDetails.accountId,
                    service_name: this.state.contactDetails.serviceName,
                    service_code: this.state.contactDetails.serviceCode,
                    connection_migration: "false",
                    new_connection_type: this.props.registerDetails.offers.connectionTypeId,
                    service_address: {
                        addr_line1: this.state.givenAddress.AddressLine1,
                        addr_line2: this.state.givenAddress.AddressLine2,
                        addr_line3: this.state.givenAddress.city,
                        addr_line4: this.state.givenAddress.state,
                        addr_line5: this.state.givenAddress.zip,
                        addr_line6: "",
                    },
                    subscriptions: servicesSubscription,
                    cancel_renewal: "true",
                    cancel_renewal_plan_id: this.props.registerDetails.generalResponse.changeBaseAddonData.planId,
                    cancel_renewal_subscription_id:
                        this.props.registerDetails.generalResponse.changeBaseAddonData.subscriptionId,
                },
            },
        };

        this.state.finalOrderReq = finalOrderReq;
        console.log("finalOrderReq>>>", finalOrderReq);
    }

    generateAddonFinalRequest() {
        var servicesSubscription = [];
        var receivedAddonDetails = this.props.registerDetails.customize.addons;
        for (var i = 0; i < receivedAddonDetails.length; i++) {
            var effective_date = receivedAddonDetails[i].effective_date;
            var effective_date_formatted = "";
            if (effective_date !== "" && effective_date !== undefined) {
                effective_date_formatted = effective_date;
            } else {
                effective_date_formatted = moment().format(this.props.configurationValues.dateFormatForBilling);
            }

            var expiry_date = receivedAddonDetails[i].expiry_date;
            var expiry_date_formatted = "";
            if (expiry_date != "" && expiry_date != undefined) {
                expiry_date_formatted = expiry_date;
            } else {
                expiry_date_formatted = moment()
                    .add(103, "years")
                    .format(this.props.configurationValues.dateFormatForBilling);
            }
            var addonsSubscriptions = {
                product_id: receivedAddonDetails[i].productId,
                product_name: receivedAddonDetails[i].productName,
                plan_id: receivedAddonDetails[i].id,
                plan_name: receivedAddonDetails[i].name,
                plan_desc: receivedAddonDetails[i].description,
                effective_date: effective_date_formatted,
                expiry_date: expiry_date_formatted,
                is_base_plan: "0",
                po_type: receivedAddonDetails[i].poType,
                po_sub_type: "0",
                subscription_type: "0",
                subscription_charges: receivedAddonDetails[i].subscriptionCharges,
                cfss: receivedAddonDetails[i].cfss,
                pogIdFromResponse: receivedAddonDetails[i].pogIdFromResponse,
            };
            if (receivedAddonDetails[i].connectionType.toUpperCase() === "POSTPAID") {
                addonsSubscriptions["apply_purchase_fee"] = "true";
            } else if (receivedAddonDetails[i].isRedeemable && parseInt(this.state.totalRewardPointsUsed) > 0) {
                addonsSubscriptions["apply_purchase_fee"] = "false";
            } else if (this.state.paymentMode === "mainBalance" || this.state.paymentMode === "mainBalanceRecharge") {
                addonsSubscriptions["apply_purchase_fee"] = "true";
            } else {
                addonsSubscriptions["apply_purchase_fee"] = "false";
            }

            servicesSubscription.push(addonsSubscriptions);
        }

        var finalOrderReq = {
            order_information: {
                order_type: "AddSubscription",
                customer_name: this.state.contactDetails.firstName + " " + this.state.contactDetails.lastName,
                contact_number: this.state.contactDetails.contactNumber,
                service_management: {
                    service_id: this.state.contactDetails.serviceId,
                    profile_id: this.state.contactDetails.profileId,
                    account_id: this.state.contactDetails.accountId,
                    service_name: this.state.contactDetails.serviceName,
                    service_code: this.state.contactDetails.serviceCode,
                    // "subscription_change_date":  moment().format("DD/MM/YYYY"),
                    // "old_base_plan_id": this.state.contactDetails.currentPlanId,
                    subscriptions: servicesSubscription,
                    service_address: {
                        addr_line1: this.state.givenAddress.AddressLine1,
                        addr_line2: this.state.givenAddress.AddressLine2,
                        addr_line3: this.state.givenAddress.city,
                        addr_line4: this.state.givenAddress.state,
                        addr_line5: this.state.givenAddress.zip,
                        addr_line6: "",
                    },
                },
                dataset: {
                    param: [
                        {
                            id: "entity_id",
                            value: "200",
                        },
                    ],
                },
            },
        };

        // if(this.state.paymentMode === "paypal" && this.props.cache.currentPlanDetails.connectionType === "1"){
        //     finalOrderReq["order_information"]["payment_details"] = {
        //         "amount": this.state.amountPaid,
        //         "comment": "Order Payment",
        //         "account_id": null,
        //         "profile_id": null,
        //         "total_amount": this.state.totalMonthlyCharges,
        //         "currency_code": "USD",
        //         "transaction_id": this.state.transactionId,
        //         "upfront_payment": "true",
        //         "payment_received": "true",
        //         "collection_source_type": "SCM",
        //         "payment_detail": [
        //           {
        //             "payment_mode": "9",
        //             "amount_paid": this.state.amountPaid,
        //             "reference_external_id": null
        //           }
        //         ]
        //     }
        // }

        if (parseInt(this.state.totalRewardPointsUsed) > 0) {
            finalOrderReq["order_information"]["service_management"]["loyalty_info"] = {
                lms_txn_id: this.state.reqId,
            };
        }

        console.log("finalOrderReq", finalOrderReq);
        this.state.finalOrderReq = finalOrderReq;
    }

    populateAddSubscriptionResponse(response) {
        var isSuccess = false;
        try {
            if (response.result_code == "0") {
                isSuccess = true;
            }
            // console.log("param",response.dataset)
            //  if (response.dataset.param[0].value && response.dataset.param[0].value != undefined) {
            //     isSuccess = true;
            // }
        } catch (err) {
            isSuccess = false;
        }
        if (isSuccess) {
            Swal.fire({
                title:
                    this.state.addSubscriptionType === "addAddon" || this.state.addSubscriptionType === "addFnFAddon"
                        ? this.props.locales.addAddonSuccessSwalMsg
                        : this.props.locales.changePlanSuccessSwalMsg,
                text: "",
                type: "",
                timer: 2000,
                showCancelButton: false,
                confirmButtonText: this.props.locales.okButtonTextInSwal,
            }).then((result) => {
                window.location.reload();
            });
        } else {
            Swal.fire("Add subscription failed", "", "");
        }
    }

    myCallback = (
        isPaymentComponentEnabled,
        isReceiptModalVisible,
        transactionId,
        finalAmountPaid,
        totalRewardPointsUsed,
        type
    ) => {
        this.setState(
            {
                paymentMode: type,
                isPaymentComponent: isPaymentComponentEnabled,
                isRechargeComponentVisible: isPaymentComponentEnabled,
                transactionId: transactionId,
                totalRewardPointsUsed: totalRewardPointsUsed,
                amountPaid: finalAmountPaid,
            },
            () => {
                this.generateUniqueReqId();
                if (parseFloat(totalRewardPointsUsed) > 0) {
                    this.setState({ isLoading: true });
                    var dataToSend = {
                        serviceId: this.state.givenAddress.serviceId,
                        requestId: this.state.reqId,
                        rewardPoints: totalRewardPointsUsed,
                        productId: this.props.cache.currentPlanDetails.productId,
                        productName: this.props.cache.currentPlanDetails.serviceName,
                    };
                    this.setState({ isLoading: true });
                    Network.executeAxios("reserveLoyaltyPoints", "POST", dataToSend, (response) => {
                        if (response && response.respCode) {
                            if (response.respCode === "SC0000") {
                                if (type === "payWithRewardPoint") {
                                    this.finalAddSubscriptionCall();
                                }
                                // if(isReceiptModalVisible == false){
                                //     this.finalAddSubscriptionCall();
                                // }
                                this.setState({ isContinue: true });
                            }
                        } else {
                            Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                        }
                        this.setState({ isReceiptModalVisible: isReceiptModalVisible, isLoading: false });
                    });
                }
                if (type === "mainBalance" || type === "nextMonthBill") {
                    this.setState({ isContinue: true });
                    this.finalAddSubscriptionCall();
                } else if (type === "mainBalanceRecharge") {
                    this.initialiseSubscriberInfo(this.state.givenAddress.serviceId);
                } else if (type === "plugNPay") {
                    this.finalAddSubscriptionCall("plugNPay");
                } else if (type === "insufficientBalance") {
                    //Swal.fire("Payment is Failed", "", "");
                } else if (isReceiptModalVisible == false && finalAmountPaid !== "") {
                    Swal.fire("Payment is Failed", "", "");
                } else {
                    this.setState({ isReceiptModalVisible: isReceiptModalVisible, isContinue: true });
                }
            }
        );
    };

    initialiseSubscriberInfo(receivedServiceId) {
        this.setState({ isLoading: true });
        Network.executeAxios(
            "fetchSubscriberInfo",
            "POST",
            { serviceId: receivedServiceId },
            (fetchSubscriberInfoResponse) => {
                this.setState({ isLoading: false });
                var maBalance = 0;
                try {
                    var params = fetchSubscriberInfoResponse.service_info.basic_details;
                    for (var i = 0; i < params.length; i++) {
                        if (params[i].id === "maBalance") {
                            maBalance = params[i].value;
                        }
                    }
                } catch (err) {}

                // var maBalanceAmount = GeneralUtils.formatNumberToStandardForm(maBalance)
                this.props.setRegisterDetails("generalResponse.maBalance", maBalance);
                this.setState({ isPaymentComponent: true });
            }
        );
    }

    generateUniqueReqId() {
        var sourceNode = "SCM";
        var instanceCode = "1";
        var requestId = sourceNode + instanceCode + moment().valueOf() + Math.floor(10 + Math.random() * 90);
        this.state.reqId = requestId;
        this.setState({ dummy: "dummy" });
    }

    receiptCallback = () => {
        this.setState({
            isReceiptModalVisible: false,
        });
        if (this.state.isContinue) {
            this.finalAddSubscriptionCall();
        } else {
            Swal.fire("Reserve Reward Points Failed", "", "");
        }
    };

    finalAddSubscriptionCall(type) {
        if (this.state.addSubscriptionType === "addAddon" || this.state.addSubscriptionType === "addFnFAddon") {
            this.generateAddonFinalRequest();
        } else if (this.state.addSubscriptionType === "changePlan") {
            this.generateChangePlanRequest();
        }
        this.setState({ isLoading: true });
        if (type === "plugNPay") {
            var dataToSend = {
                billingName: this.state.contactDetails.firstName + " " + this.state.contactDetails.lastName,
                finalReq: this.state.finalOrderReq,
                addSubscriptionType: this.state.addSubscriptionType,
                amount: this.state.amountPaid,
                creditExpiryDate: this.state.creditExpiryDate,
            };

            Network.executeAxios("addSubscriptionWithPowerTranz", "POST", dataToSend, (Response) => {
                this.setState({ isLoading: false });
                if(Response.STATUS === "SUCCESS"){
                    // console.log("powertranzInitialResponse >> "+Response.redirectData);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth' // smooth scroll
                    });
                    this.setState({ 
                        powertranzOrderId: Response.OrderIdentifier, 
                        powertranzTransId: Response.TransactionIdentifier, 
                        powertranzInitialResponse: Response.redirectData 
                    });
                } else {
                    Swal.fire("Please try again later.");
                }
                // this.setState({ isLoading: false, plugNPayInitialResponse: Response });
                // window.location.replace("./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse)));
            });
        } else {
            var dataToSend1 = {
                finalReq: this.state.finalOrderReq,
                addSubscriptionType: this.state.addSubscriptionType,
            };
            Network.executeAxios("addSubscription", "POST", dataToSend1, (response) => {
                this.populateAddSubscriptionResponse(response);
                this.setState({ isLoading: false });
            });
        }
    }

    tabClicked(type) {
        for (var i = 0; i < this.state.givenAddress.allServiceId.length; i++) {
            if (this.state.givenAddress.allServiceId[i].serviceId === type) {
                this.state.givenAddress.allServiceId[i]["status"] = true;
            } else {
                this.state.givenAddress.allServiceId[i]["status"] = false;
            }
            this.setState({ tab: type, tabNew: "" });
        }
        for (var j = 0; j < this.props.registerDetails.services.length; j++) {
            this.props.registerDetails.services[j]["status"] = false;
        }
    }

    populateServiceDetailsComponent() {
        var currentService = this.props.registerDetails.offers;
        var packageAmount = 0;
        var packageAmount_sup = 0;
        var Price = GeneralUtils.formatNumberToStandardForm(
            currentService.basePriceWithDiscount,
            this.props.configurationValues
        );
        Price = Price.split(".");
        packageAmount = Price[0];
        if (Price.length > 1) {
            packageAmount_sup = Price[1];
        } else {
            packageAmount_sup = "00";
        }
        var activePlanName = currentService.name;
        var activePlanDesc = currentService.description;
        var activePlanAmount = packageAmount;
        var activePlanDecimal = packageAmount_sup;
        var discountArr = currentService.discountArray;
        var taxArr = currentService.taxArray;
        var offerAmount = currentService.offerAmount;

        return (
            <div className="py-3 mb-2 customerSummaryBox">
                <div className="col-md-12 p-0 m-0">
                    <div className="col-md-12 m-0 d-flex justify-content-between">
                        <div style={{ color: "#FFFFFF", fontSize: 16, fontWeight: 500 }}>{activePlanName}</div>
                        <div className="d-flex">
                            <div className="ml-2 d-flex justify-content-end" style={{ color: "#FFFFFF" }}>
                                <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span>
                                <span style={{ fontSize: 18, lineHeight: "20px", fontWeight: 600 }}>
                                    {activePlanAmount}
                                </span>
                                <span style={{ fontSize: 12, fontWeight: 600 }}>{activePlanDecimal}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 m-0 d-flex justify-content-between">
                        <div style={{ color: "#FFFFFF", fontSize: 12 }}>Offer Description : {activePlanDesc}</div>
                        {/* {
                                discountArr.length > 0 ?
                                <div style={{ fontSize: 10, color: '#FFFFFF' }}>(Base Price - Discount)</div>
                                :
                                <div style={{ fontSize: 10, color: '#FFFFFF' }}>(Base Price)</div>
                                } */}
                    </div>
                </div>
                <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                    <div className="d-flex">
                        <div style={{ fontSize: 12, color: "#FFFFFF" }}>Base Price</div>
                        <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                            {Constants.dollarSign}
                            {GeneralUtils.formatNumberToStandardForm(
                                parseFloat(offerAmount),
                                this.props.configurationValues
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                    {discountArr.map((itemArr, key) => {
                        return (
                            <div className="d-flex" key={key}>
                                <div style={{ fontSize: 12, color: "#FFFFFF" }}>{itemArr.discountName}</div>
                                <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                                    -{Constants.dollarSign}
                                    {GeneralUtils.formatNumberToStandardForm(
                                        parseFloat(itemArr.discountPrice),
                                        this.props.configurationValues
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                    {taxArr.map((itemArr, key) => {
                        return (
                            <div className="d-flex" key={key}>
                                <div style={{ fontSize: 12, color: "#FFFFFF" }}>{itemArr.taxName}</div>
                                <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                                    +{Constants.dollarSign}
                                    {GeneralUtils.formatNumberToStandardForm(
                                        parseFloat(itemArr.taxPrice),
                                        this.props.configurationValues
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    populateAddonDetailsComponent() {
        const populateAddonCharges = this.props.registerDetails.customize.addons.map((item, key) => {
            var rewardPoint =
                parseFloat(item.count * item.addonPriceWithDiscount) * parseInt(this.state.redemptionPoint);
            var packageAmount = 0;
            var packageAmount_sup = 0;
            var price = GeneralUtils.formatNumberToStandardForm(
                item.count * item.addonPriceWithDiscount,
                this.props.configurationValues
            );
            price = price.split(".");
            packageAmount = price[0];
            if (price.length > 1) {
                packageAmount_sup = price[1];
            } else {
                packageAmount_sup = "00";
            }
            var discountArr = item.discountArray;
            var taxArr = item.taxArray;
            var offerAmount = item.offerAmount;
            return (
                <div key={key} className="py-3 mb-2 customerSummaryBox">
                    <div className="col-md-12 p-0 m-0">
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                            <div style={{ color: "#FFFFFF", fontSize: 16, fontWeight: 500 }}>
                                {item.name}{" "}
                                {item.isIncluded ? (
                                    <span style={{ fontSize: 12, color: "#231F20" }}>(Included)</span>
                                ) : null}
                            </div>
                            <div className="d-flex">
                                {item.isIncluded ? null : (
                                    <div className="ml-2 d-flex justify-content-end" style={{ color: "#FFFFFF" }}>
                                        <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span>
                                        <span style={{ fontSize: 18, lineHeight: "20px", fontWeight: 600 }}>
                                            {packageAmount}
                                        </span>
                                        <span style={{ fontSize: 12, fontWeight: 600 }}>{packageAmount_sup}</span>
                                        {item.isRedeemable ? (
                                            <span className="" style={{ color: "#FF8F18", fontSize: 12 }}>
                                                ({rewardPoint} pts)
                                            </span>
                                        ) : null}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                            <div style={{ color: "#FFFFFF", fontSize: 12 }}>
                                Add-on Description : {item.description}
                            </div>
                            {/* {item.isIncluded ? null
                                : 
                                discountArr.length > 0 ?
                                <div style={{ fontSize: 10, color: '#FFFFFF' }}>(Base Price - Discount)</div>
                                :
                                <div style={{ fontSize: 10, color: '#FFFFFF' }}>(Base Price)</div>
                                } */}
                        </div>
                    </div>
                    <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                        <div className="d-flex" key={key}>
                            <div style={{ fontSize: 12, color: "#FFFFFF" }}>Base Price</div>
                            <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                                {Constants.dollarSign}
                                {GeneralUtils.formatNumberToStandardForm(
                                    parseFloat(offerAmount),
                                    this.props.configurationValues
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                        {discountArr.map((itemArr, key) => {
                            return (
                                <div className="d-flex" key={key}>
                                    <div style={{ fontSize: 12, color: "#FFFFFF" }}>{itemArr.discountName}</div>
                                    <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                                        -{Constants.dollarSign}
                                        {GeneralUtils.formatNumberToStandardForm(
                                            parseFloat(itemArr.discountPrice * item.count),
                                            this.props.configurationValues
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                        {taxArr.map((itemArr, key) => {
                            return (
                                <div className="d-flex" key={key}>
                                    <div style={{ fontSize: 12, color: "#FFFFFF" }}>{itemArr.taxName}</div>
                                    <div className="ml-4" style={{ color: "#FFFFFF", fontSize: 12, fontWeight: 400 }}>
                                        +{Constants.dollarSign}
                                        {GeneralUtils.formatNumberToStandardForm(
                                            parseFloat(itemArr.taxPrice),
                                            this.props.configurationValues
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        });

        return <div className="pt-4">{populateAddonCharges}</div>;
    }

    populateCustomerSummary() {
        return (
            <div className="col-md-12 m-0 p-0 customerSummaryBox py-3">
                <div className="col-md-12 m-0 summaryBoxHeading">
                    {this.props.locales.customerSummaryHeadingInAddSubscriptionSummary}
                </div>
                <div className="col-md-12 m-0 p-0">
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.nameLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div className="col-9 summaryBoxData" style={{ wordBreak: "break-word" }}>
                            : &nbsp;{this.state.contactDetails.firstName} {this.state.contactDetails.lastName}
                        </div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.contactNumLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div className="col-9 summaryBoxData">
                            : &nbsp;{this.state.contactDetails.contactNumber || "NA"}
                        </div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.emailLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div
                            className="col-9 summaryBoxData"
                            title={this.state.contactDetails.contactEmailAddress}
                            style={{ wordBreak: "break-word" }}
                        >
                            : &nbsp;{this.state.contactDetails.contactEmailAddress || "NA"}
                        </div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.accountNumLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div className="col-9 summaryBoxData">: &nbsp;{this.state.contactDetails.accountId}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.customerNumLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div className="col-9 summaryBoxData">: &nbsp;{this.state.contactDetails.profileId}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">
                            {this.props.locales.customerAddressLabelInCustomerSummaryAddSubscription}
                        </div>

                        <div className="col-9 summaryBoxData">
                            : &nbsp;{this.state.givenAddress.AddressLine1}, {this.state.givenAddress.city},{" "}
                            {this.state.givenAddress.state}, {this.state.givenAddress.zip}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    arrowButtonClicked(type) {
        this.setState({ isCartVisibleForMobile: type });
    }

    chooseOfferClicked() {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
        if (this.state.addSubscriptionType === "addAddon") {
            this.props.setCurrentPage("pageName", "addons");
        } else if (this.state.addSubscriptionType === "changePlan") {
            this.props.setCurrentPage("pageName", "services");
        } else if (this.state.addSubscriptionType === "addFnFAddon") {
            this.props.setCurrentPage("pageName", "fnfAddons");
        }
    }

    render() {
        if (this.state.redirectToMyAccount) {
            return <MyAccountComponent feature={this.state.feature} />;
        }
        return (
            <div>
                {this.state.isLoading ? (
                    <LoadingAnimation isVisible={true} />
                ) : (
                    <>
                        {this.state.powertranzInitialResponse ?  this.renderPowertranzPaymentPart() : this.componentContent()}
                        {/* {this.state.plugNPayInitialResponse ? this.renderPaymentPart() : this.componentContent()} */}

                        {this.state.isPaymentComponent ? (
                            <PaymentComponent
                                accountId={this.state.contactDetails.accountId}
                                firstName={this.state.contactDetails.firstName}
                                lastName={this.state.contactDetails.lastName}
                                phoneNumber={this.state.contactDetails.contactNumber}
                                emailId={this.state.contactDetails.contactEmailAddress}
                                profileId={this.state.contactDetails.profileId}
                                amount={this.state.totalMonthlyCharges}
                                totalAmountToPay={this.state.totalAmountToPay}
                                callbackFromParent={this.myCallback}
                            />
                        ) : null}
                    </>
                )}
            </div>
        );
    }

    renderPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe
                    title="payment"
                    src={
                        "./plugNPay.html?responseData=" +
                        encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse))
                    }
                    style={{ width: "100%", border: "none", height: 1100 }}
                    className=""
                >
                    {" "}
                </iframe>
            </div>
        );
    };

    renderPowertranzPaymentPart = () => {
        return (
            <div className="tsysContainer col-md-12">
                <iframe title="powertranz" 
                    srcDoc={this.state.powertranzInitialResponse} 
                    style={{ width: "100%", border: "none", height:1100 }}>
                    {" "}
                </iframe>
            </div>
        );
    };

    componentContent() {
        return (
            <div id="changePlanConfirmationMainContainer" className="mt-4">
                {this.state.isCartVisibleForMobile == false ? (
                    <div style={{ width: "92%", marginBottom: 100 }} className="ml-auto">
                        <div className="col-md-12 p-0 pb-3 pt-sm-0 pt-5">
                            <div className="col-md-12 p-0" style={{ color: "#231F20", fontSize: 24, fontWeight: 500 }}>
                                Order Summary
                            </div>
                            <div
                                style={{ color: "#407CCA", fontSize: 12 }}
                                className="pt-1 d-block d-md-none"
                                onClick={() => {
                                    this.chooseOfferClicked();
                                }}
                            >
                                {" "}{'>'}{" "}
                                {this.state.addSubscriptionType === "addAddon" ||
                                this.state.addSubscriptionType === "addFnFAddon"
                                    ? "Choose Addon"
                                    : "Choose Offer"}{" "}
                            </div>
                        </div>
                        <div className="col-md-12 p-0">
                            <div className="col-md-12 row p-0 m-0">
                                <div className="col-md-8 p-0 pb-4 pr-sm-5 pr-4" id="orderSummaryPart">
                                    <div className="col-md-12 p-0 m-0">
                                        <div className="col-md-12 p-0 m-0">{this.populateCustomerSummary()}</div>
                                    </div>
                                    <div className="col-md-12 my-4 py-3 customerSummaryBox">
                                        Service Address :{" "}
                                        <span style={{ fontWeight: 500 }}>
                                            {this.state.givenAddress.AddressLine1}, {this.state.givenAddress.city},{" "}
                                            {this.state.givenAddress.state}, {this.state.givenAddress.zip}
                                        </span>
                                    </div>

                                    <div className="col-md-12 p-0">
                                        <div className="pb-2">
                                            <div className="col-md-12 p-0">
                                                <div
                                                    className="col-md-12 p-0"
                                                    style={{ fontSize: 16, fontWeight: 600, color: "#000000" }}
                                                >
                                                    Order Details
                                                </div>
                                                {this.state.addSubscriptionType === "addAddon"
                                                    ? this.populateAddonDetailsComponent()
                                                    : this.populateServiceDetailsComponent()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-block d-md-none bottomCartPartForMobile" style={{ bottom: 0 }}>
                            <div className="d-flex flex-column">
                                <div className="d-flex justify-content-center pt-2">
                                    <img
                                        src={PathIcon}
                                        alt=""
                                        onClick={() => {
                                            this.arrowButtonClicked(true);
                                        }}
                                    />
                                </div>
                                <div className="d-flex align-items-center justify-content-between px-3 pb-1">
                                    <div className="amountContainer">
                                        <div>Total</div>
                                        <div style={{ fontSize: 28 }}>
                                            {Constants.dollarSign}
                                            {GeneralUtils.formatNumberToStandardForm(
                                                this.state.totalMonthlyCharges,
                                                this.props.configurationValues
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            className="blueButtonContainer"
                                            onClick={() => {
                                                this.confirmationSubmitButtonClicked();
                                            }}
                                        >
                                            {this.props.locales.checkoutButtonTextInAddSubscription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="col-md-4 p-0 pb-4" style={{ marginTop: "110px" }}>
                        <div className="">
                            {this.state.addSubscriptionType === "addAddon" ||
                            this.state.addSubscriptionType === "addFnFAddon" ? (
                                <AddonCartComponent
                                    currentServiceDetails={{ serviceCharge: this.state.allCurrentActiveServiceCharge }}
                                />
                            ) : null}
                            {this.state.addSubscriptionType === "changePlan" ? (
                                <ServiceCartComponent
                                    currentServiceDetails={{ serviceCharge: this.state.allCurrentActiveServiceCharge }}
                                />
                            ) : null}
                        </div>
                        <div className="d-block d-md-none bottomCartPartForMobile" style={{ top: 0 }}>
                            <div className="d-flex flex-column">
                                <div className="d-flex align-items-center justify-content-between px-3 pt-1">
                                    <div className="amountContainer">
                                        <div>Total</div>
                                        <div style={{ fontSize: 28 }}>
                                            {Constants.dollarSign}
                                            {GeneralUtils.formatNumberToStandardForm(
                                                this.state.totalMonthlyCharges,
                                                this.props.configurationValues
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            className="blueButtonContainer"
                                            onClick={() => {
                                                this.confirmationSubmitButtonClicked();
                                            }}
                                        >
                                            {this.props.locales.checkoutButtonTextInAddSubscription}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center pb-2">
                                    <img
                                        className="rotate180"
                                        src={PathIcon}
                                        alt=""
                                        onClick={() => {
                                            this.arrowButtonClicked(false);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div
                    className="col-md-12 changePlanBottomDiv d-flex justify-content-end align-items-center"
                    style={{ zIndex: 0 }}
                >
                    <div
                        className="blueButtonContainer mr-3"
                        onClick={() => {
                            this.confirmationBackButtonClicked();
                        }}
                    >
                        Back
                    </div>
                    <div
                        className="blueButtonContainer"
                        onClick={() => {
                            this.confirmationSubmitButtonClicked();
                        }}
                    >
                        Submit
                    </div>
                </div>

                {this.state.isReceiptModalVisible ? (
                    <ReceiptComponent
                        amount=""
                        isVisible={true}
                        content={this.props.locales.paymentSuccessTitleInSwal}
                        transactionId={this.state.transactionId}
                        serviceId={this.state.contactDetails.serviceId}
                        finalRechargeAmount={this.state.amountPaid}
                        callback={this.receiptCallback}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        currentPage: state.currentPage,
        cache: state.cache,
        configurationValues: state.configurationValues,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        setPlanDetails: function (key, payload) {
            dispatch(setPlanDetails(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
    };
}

const AddonsConfirmationComponentContainer = connect(mapStateToProps, mapDispatchToProps)(AddonsConfirmationComponent);

export default AddonsConfirmationComponentContainer;
